var _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "30px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74 30.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "3px",
    x1: 72.5,
    y1: 15.06,
    x2: 1.6,
    y2: 15.06
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "3px",
    x1: 16.15,
    y1: 28.55,
    x2: 1.51,
    y2: 15.22
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "3px",
    x1: 16.02,
    y1: 1.5,
    x2: 1.5,
    y2: 15.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrowLeft);
export default __webpack_public_path__ + "static/media/long-arrow-left.66f8873812a765d0f3dc72711c2b97bc.svg";
export { ForwardRef as ReactComponent };